import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'

import AlwayzImage from '../components/molecules/AlwayzImage.jsx'
import AltoonHorizontalReaderPage from '../components/templates/AltoonHorizontalReaderPage'
import BottomSection from '../components/templates/BottomSection'
import ChapterHandler from '../components/templates/ChapterHandler'
import GuideTutorial from '../components/templates/GuideTutorial'
import HeaderComponent from '../components/templates/HeaderComponent'
import RecommendRelatedToonsComponent from '../components/templates/RecommendRelatedToonsComponent.jsx'
import MainToonComponent from '../components/templates/mainToonComponent.jsx'
import useChapterData from '../hooks/useChapterData'
import UserStore from '../stores/UserStore.jsx'
import backendApis from '../utils/backendApis.jsx'
import { useLocation } from 'react-router-dom'
import LoadingIndicator from '../components/atoms/loadingIndicator'

const ToonReaderScreen = ({ params }) => {
  const scrollContainerRef = useRef(null)
  const location = useLocation()
  const historyCountRef = useRef(0)

  const [guideOn, setGuideOn] = useState(true)
  const [guideTutorialOn, setGuideTutorialOn] = useState(false)

  const chapterInfo = location.state?.usr?.chapterInfo
  const toonInfo = location.state?.usr?.toonInfo
  const episode = location.state?.usr?.episode
  const rentPeriod = location.state?.usr?.rentPeriod || 3

  const chapterId = chapterInfo?._id

  const { chapter, relatedToonInfo, previousChapter, nextChapter, viewLog, isLoading, error } =
    useChapterData(chapterId, toonInfo, episode)

  const toonId = toonInfo?._id
  const toonType = toonInfo?.toonType

  useEffect(() => {
    const logReadingProgress = async () => {
      // 독서 진행 상태를 로깅하는 API 호출
      try {
        await backendApis.logChapterViewed(toonId, chapterInfo?._id, rentPeriod)
      } catch (error) {
        console.error('Failed to log reading progress:', error)
      }
    }

    // 사용자가 새로운 챕터를 시작할 때마다 독서 진행 상태를 로깅
    logReadingProgress()
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0
    }

    setTimeout(() => {
      UserStore.setIsLoaded(true)
    }, 500)
  }, [chapterInfo, toonInfo, episode])

  useEffect(() => {
    if (toonInfo?.toonType === 'HorizontalScroll_reverse' && episode === 1) {
      setGuideTutorialOn(true)
    }
  }, [])

  useEffect(() => {
    // URL이 변경될 때마다 카운트 증가
    historyCountRef.current += 1
  }, [location.pathname, location.search]) // URL이나 쿼리 파라미터가 변경될 때마다 실행

  // useEffect(() => {
  //   if (toonType === 'VerticalScroll') {
  //     const timer = setTimeout(() => {
  //       setGuideOn(false)
  //     }, 3000)
  //     // 3000ms = 3s

  //     return () => {
  //       clearTimeout(timer)
  //     }
  //   }
  // }, [guideOn, chapterInfo, toonInfo, episode])

  useEffect(() => {
    // 이전에 보던 스크롤 위치가 있다면 해당 위치로 이동
    const savedPosition = sessionStorage.getItem(`reader_scrollPosition_${chapterId}`)
    if (savedPosition) {
      setTimeout(() => {
        scrollContainerRef.current.scrollTop = parseInt(savedPosition, 10)
      }, 100)
    }
  }, [])

  useEffect(() => {
    // window.ReactNativeWebView 존재 여부 확인
    const isInWebView = 'ReactNativeWebView' in window

    if (isInWebView) {
      const handleScreenGuard = (type) => {
        try {
          if (type === 'disable') {
            window.ReactNativeWebView.postMessage(
              JSON.stringify({
                type: 'disableScreenCapture',
                boolean: false,
              })
            )
          } else {
            window.ReactNativeWebView.postMessage(
              JSON.stringify({
                type: 'enableScreenCapture',
                boolean: false,
              })
            )
          }
        } catch (error) {
          console.log('스크린 가드 postMessage 오류:', error)
        }
      }

      window.addEventListener('screenGuard', handleScreenGuard('disable'))

      return () => {
        window.addEventListener('screenGuard', handleScreenGuard('enable'))
      }
    }
  }, [])

  const handleScreenTap = () => setGuideOn(!guideOn)

  const ScrollButton = () => {
    return (
      <div
        type="button"
        className={`w-[10vw] fixed bottom-[10vh] right-4 ${
          guideOn ? 'opacity-100 animate-slideUp' : 'opacity-0 animate-slideDownFade'
        }`}
      >
        <button
          type="button"
          className="rounded-full bg-white shadow-md"
          onClick={() => {
            if (scrollContainerRef.current) {
              scrollContainerRef.current.scrollTop = 0
            }
          }}
        >
          <img src="/images/toon/toTopIcon.png" alt="up" className="w-full" />
        </button>
        <button
          type="button"
          className="rounded-full bg-white shadow-md"
          onClick={() => {
            if (scrollContainerRef.current) {
              scrollContainerRef.current.scrollTop = scrollContainerRef.current.scrollHeight
            }
          }}
        >
          <img src="/images/toon/toBottomIcon.png" alt="up" className="w-full" />
        </button>
      </div>
    )
  }

  if (!UserStore?.isLoaded) {
    return <LoadingIndicator isLoading={isLoading} />
  }

  return (
    <div
      ref={scrollContainerRef}
      className={`w-full h-[100vh] overflow-x-hidden ${
        toonType?.includes('HorizontalScroll') ? 'overflow-y-hidden' : 'overflow-y-scroll'
      } `}
    >
      <HeaderComponent
        chapterInfo={chapterInfo}
        nextChapter={nextChapter}
        guideOn={guideOn}
        handleModal={() => {
          UserStore.setBottomsheetOpened(true)
        }}
        historyCountRef={historyCountRef}
      />

      {toonType === 'VerticalScroll' && (
        <button type="button" className="w-full flex flex-col" onClick={handleScreenTap}>
          {chapter?.contents?.map((content, index) => (
            <AlwayzImage
              src={content}
              key={index || content}
              alt={chapterInfo?.title}
              placeholder={
                <div
                  style={{
                    background: '#d8d8d8',
                    width: '100%',
                    height: '100%',
                    position: 'relative',
                    minHeight: '100vh',
                  }}
                />
              }
              lazy
            />
          ))}
        </button>
      )}

      {toonType?.includes('HorizontalScroll') && chapter?.contents?.length > 0 && (
        <AltoonHorizontalReaderPage
          currentChapter={chapter?.episode}
          previousChapter={previousChapter}
          nextChapter={nextChapter}
          toonInfo={toonInfo}
          chapterInfo={chapterInfo}
          guideOn={guideOn}
          setGuideOn={setGuideOn}
          contents={chapter?.contents}
          handleScreenTap={handleScreenTap}
          viewLog={viewLog}
          direction={toonType === 'HorizontalScroll' ? 'ltr' : 'rtl'}
        />
      )}

      {toonType === 'VerticalScroll' && (
        <>
          {/* 다음화 보기 버튼, 마지막화일땐 숨기기 */}
          {nextChapter && (
            <ChapterHandler
              nextChapter={nextChapter}
              toonInfo={toonInfo}
              rentPeriod={rentPeriod}
              guideOn={guideOn}
              viewLog={viewLog}
            />
          )}

          {chapterInfo?.relatedToonInfo && (
            <div className="mx-[4vw] py-[4vw] font-semibold text-[4vw]">
              <div className="pb-[2vw]">
                {chapterInfo?.relatedToonInfo?.relatedToonTitle || '이 작품은 어때요?'}
              </div>
              {relatedToonInfo?.map((toon, index) => (
                <div key={toon?._id} className="mb-[4vw] rounded-lg border bg-white">
                  <MainToonComponent toon={toon} index={index} type="relatedToon" />
                </div>
              ))}
            </div>
          )}
          {!nextChapter ||
            (moment().isSameOrBefore(
              moment(nextChapter?.publishedAt).subtract(toonInfo?.previewDays || 8, 'days')
            ) &&
              UserStore?.userData?.isAdmin !== true) ||
            ((nextChapter?.isFree === false || moment().isBefore(nextChapter?.publishedAt)) && (
              <div className="mx-[4vw]">
                <RecommendRelatedToonsComponent toonInfo={toonInfo} type="relatedToonsReader" />
              </div>
            ))}
        </>
      )}

      {guideTutorialOn && <GuideTutorial setGuideTutorialOn={setGuideTutorialOn} />}

      {guideOn && toonType === 'VerticalScroll' && (
        <>
          <ScrollButton />
          <BottomSection
            currentChapter={chapter?.episode}
            previousChapter={previousChapter}
            nextChapter={nextChapter}
            toonInfo={toonInfo}
            chapterInfo={chapterInfo}
            guideOn={guideOn}
            style={{ display: guideOn ? 'flex' : 'none' }}
            viewLog={viewLog}
            rentPeriod={rentPeriod}
          />
        </>
      )}
    </div>
  )
}

export default ToonReaderScreen
